module.exports = function() {
  return new Worker(__webpack_public_path__ + "8256151e522946f64f3a.worker.js");
};